import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy
} from '@angular/core';
import {
  ParticipantsBehaviourList
} from '../../../../../../models/participants-behaviour-list';
import {MatTableDataSource} from '@angular/material/table';
import {Subject, takeUntil} from 'rxjs';
import {CommonService} from '../../../../../shared/services/common.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../../../state/app.state';
import {Sort} from '@angular/material/sort';
import {sortOrderMap, userStatusMap} from '../../../../../shared/constants/common.constants';
import {
  configId,
  participantsBehaviourList
} from '../../../core/group-dashboard.selector';
import {
  FetchParticipantsBehaviourListRequest
} from '../../../core/group-dashboard.actions';
import {GroupDashboardService} from '../../../services/group-dashboard.service';
import {ParticipantAndCaregiver} from '../../../../../../models/participantAndCaregiver';
import {drillDownUrls} from '../../../../../shared/core/shared.selectors';
import {SetDrillDownUrls} from '../../../../../shared/core/shared.actions';

@Component({
  selector: 'app-participant-behaviour-information-table',
  templateUrl: './participant-behaviour-information-table.component.html',
  styleUrls: ['./participant-behaviour-information-table.component.css']
})
export class ParticipantBehaviourInformationTableComponent implements AfterViewInit,
  OnDestroy {
  @Input() loading: boolean = false;
  @Input() noDataMessage = 'No Data Available';
  isFirstPage = true;
  selectedConfigId: number = 1;
  participantBehaviourTableConfig = {
    1: [
      {
        type: 'string',
        key: 'name',
        displayName: 'Name'
      },
      {
        type: 'number',
        key: 'rl_weekly_journal_entry_count',
        displayName: 'Past week days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'rl_eaten_vs_goal',
        displayName: 'Past week red light foods eaten/goal',
        bodyTextAlign: 'center'
      },
      {
        type: 'number',
        key: 'rl_total_days_journaled',
        displayName: 'Total days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'rl_goal_met_vs_set',
        displayName: 'Total no. of red light foods goals met/set',
        bodyTextAlign: 'center'
      }
    ],
    2: [
      {
        type: 'string',
        key: 'name',
        displayName: 'Name'
      },
      {
        type: 'number',
        key: 'pa_weekly_journal_entry_count',
        displayName: 'Past week days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'pa_done_vs_goal',
        displayName: 'Past week physical activity goal',
        bodyTextAlign: 'center'
      },
      {
        type: 'number',
        key: 'pa_total_days_journaled',
        displayName: 'Total days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'pa_goal_met_vs_set',
        displayName: 'Total no. of physical activity goals met/set',
        bodyTextAlign: 'center'
      }
    ],
    3: [
      {
        type: 'string',
        key: 'name',
        displayName: 'Name'
      },
      {
        type: 'number',
        key: 'st_weekly_journal_entry_count',
        displayName: 'Past week days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'st_used_vs_goal',
        displayName: 'Past week screen time used/goal',
        bodyTextAlign: 'center'
      },
      {
        type: 'number',
        key: 'st_total_days_journaled',
        displayName: 'Total days journaled',
        bodyTextAlign: 'center'
      },
      {
        type: 'string',
        key: 'st_goal_met_vs_set',
        displayName: 'Total no. of screen time goals met/set',
        bodyTextAlign: 'center'
      }
    ]

  }
  config = [];
  participantBehaviourList: ParticipantsBehaviourList;
  tableData: any[];
  dataSource: any = new MatTableDataSource();
  displayedColumns: any;
  sortOrder: any = 1;
  sortColumn: any = 'name'
  clientId: any;
  groupId: any;
  isDrillDown: boolean = false;
  private participantBehaviourFilters: {
    clientId?: number,
    groupId?: number,
    role?: number[],
    session?: number,
    status?: number[],
    searchText?: string,
  } = null;
  private readonly OnDestroy: Subject<any> = new Subject<any>();

  constructor(
    private cdRef: ChangeDetectorRef,
    private groupDashboardService: GroupDashboardService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private router: Router,
    private store?: Store<fromRoot.State>
  ) {
    const params: any = this.route.snapshot.params;
    this.groupId = params?.groupId;
    this.isDrillDown = !!(params && params['groupId']);

    this.store.select(participantsBehaviourList)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.loading = data.loading;
        this.participantBehaviourList = data;


        if (!data.loading) {
          this.dataSource.data = [...data.list];

          if (data.hasNext) {
            setTimeout(() => {
              if (this.sortColumn && data.pageNumber === 1) {
                this.commonService.scrollColumnInView(this.sortColumn);
              }
            }, 0)

            setTimeout(() => {
              // check window height for infinite scroll
              this.commonService.checkInfiniteScrollHeightAndCallNext('table-wrapper', () => {
                this.onScroll();
              });
            }, 0);
          }
        }
      });

    this.store.select(configId)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.selectedConfigId = data;
        this.config = this.participantBehaviourTableConfig[data];
        this.displayedColumns = this.config?.map((eachObject) => eachObject.key);
      });


    // listen for filter changes from the filter component
    this.groupDashboardService.onParticipantBehaviourInformationFilterChange.pipe(takeUntil(this.OnDestroy))
      .subscribe((filters) => {
        this.participantBehaviourFilters = filters;

        this.isFirstPage = true;
        if (this.participantBehaviourFilters) {
          this.fetchParticipantBehaviourInformation();
        }
      })
  }

  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.tableData);
    this.displayedColumns = this.config.map((eachObject) => eachObject.key);
    this.cdRef.detectChanges();
  }

  sortData(sort: Sort) {
    this.isFirstPage = true;
    this.sortColumn = `${sort.active}`;
    this.sortOrder = sortOrderMap[sort.direction];

    this.fetchParticipantBehaviourInformation();
  }

  onScroll() {
    if (this.participantBehaviourList?.hasNext && !this.participantBehaviourList?.loading) {
      this.fetchParticipantBehaviourInformation(this.participantBehaviourList.pageNumber + 1, this.participantBehaviourList.limit);
      this.isFirstPage = false;
    }
  }

  fetchParticipantBehaviourInformation(pageNumber = 1, limit = 10) {
    const payload = {
      ...this.participantBehaviourFilters,
      recordType: this.selectedConfigId,
      pageNumber,
      limit,
      ...(this.sortOrder ? {sortOrder: this.sortOrder} : {}),
      ...(this.sortOrder ? {sortColumn: this.sortColumn} : {}),
      groupId: this.groupId
    }
    if (this.selectedConfigId) {
      this.store.dispatch(FetchParticipantsBehaviourListRequest({payload}));
    }
  }

  openUserDetails(user: ParticipantAndCaregiver) {
    if (user?.id) {
      this.store.select(drillDownUrls).subscribe(data => {
        const updatedDrillDownUrls = [...data, this.router.url];
        if ([...data].pop() !== this.router.url) {
          this.store.dispatch(SetDrillDownUrls({payload: updatedDrillDownUrls}));
        }
      }).unsubscribe();

      const urlPrefix = this.router.url.split('/')[1];
      this.router.navigate([`/${urlPrefix}/member/${user.id}/behavior-tracker`]);
    }
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }

  protected readonly userStatusMap = userStatusMap;
}
